import { Space, Layout } from 'design-system';

import Footer from 'src/components/common/Footer';

import Header from '../common/header-simple';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function CompactLayout({ children }: Props) {
  return (
    <>
      <Header />

      <Layout.Content>
        <Space
          direction="vertical"
          style={{
            padding: 'var(--layout-padding)',
            margin: 'auto',
            maxWidth: 400,
            minHeight: '100vh',
            textAlign: 'center',
            justifyContent: 'center',
            display: 'flex',
          }}
        >
          {children}
        </Space>
        <Footer />
      </Layout.Content>
    </>
  );
}
